import actions from './actions';

const initState = {
    devices: [],
    errors: {},
    loading: false,
    deviceInfo: {},
    editView: false,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_DEVICES:
            return {
                ...state,
                loading: true,
                editView: false,
            };
        case actions.FETCH_DEVICES_SUCCESS:
            return {
                ...state,
                devices: action.devices,
                loading: false,
                editView: false,
            };
        case actions.FETCH_DEVICES_ERROR:
            return {
                ...state,
                devices: [],
                loading: false,
                editView: false,
            };
        default:
            return state;
    }

}
